const teamModal = {
  modalElement: null,
  teamList: [],
  teamModalPages: [],
  currentCard: null,
  initTeamModal: () => {
    if (document.getElementById('team-modal')) {
      // Get Modal Element
      teamModal.modalElement = document.getElementById('team-modal');

      // Append modal to main
      const main = document.querySelector('main');
      main.appendChild(teamModal.modalElement);

      // Get displayed employee IDs
      const teamCards = document.querySelectorAll('.team-card');
      teamCards.forEach((employee) => {
        teamModal.teamList.push(employee.dataset.id);
      });

      // Get modal pages
      teamModal.teamModalPages = Array.from(document.querySelectorAll('.team-modal-page'));

      // Move individual team modals to Modal Element
      const newModal = document.getElementById('team-modal');
      teamModal.modalElement = newModal;
      teamModal.teamModalPages.forEach((employee) => {
        newModal.appendChild(employee);
        employee.classList.add('loaded');
      });

      // Get close buttons
      const closeButtons = teamModal.modalElement.querySelectorAll('.close');

      // Get Prev & Next buttons
      const nextButtons = teamModal.modalElement.querySelectorAll('.next');
      const prevButtons = teamModal.modalElement.querySelectorAll('.prev');

      // Add click listeners
      teamModal.modalElement.addEventListener('click', function (e) {
        teamModal.clickOutsideToClose(e);
      });
      teamCards.forEach((card) => {
        card.addEventListener('click', function (e) {
          teamModal.openModal(e);
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', teamModal.closeModal);
      });

      nextButtons.forEach((button) => {
        button.addEventListener('click', teamModal.nextCard);
      });

      prevButtons.forEach((button) => {
        button.addEventListener('click', teamModal.prevCard);
      });
    }
  },
  openModal: (e) => {
    // Set Modal overlay to top and display
    teamModal.modalElement.classList.add('active');
    teamModal.currentCard = e.target.closest('.team-card').dataset.id;

    teamModal.teamModalPages.forEach((page) => {
      if (page.dataset.id === teamModal.currentCard) {
        setTimeout(() => {
          // Fade in modal background
          teamModal.modalElement.classList.add('show');
        }, 100);
        setTimeout(() => {
          // Slide in Page
          page.classList.add('active');
        }, 200);
      }
    });

    // Set button state
    teamModal.setButtons();

    // Prevent scrolling of background when modal open
    const doc = document.querySelector('body');
    doc.classList.add('no-scroll');
  },
  closeModal: () => {
    // Fade out modal background
    teamModal.modalElement.classList.remove('show');
    const modalPages = teamModal.modalElement.querySelectorAll('.team-modal-page');

    modalPages.forEach((page) => {
      if (page.classList.contains('active')) {
        // Slide out page
        page.classList.remove('active');

        setTimeout(() => {
          // Remove modal from top and hide
          teamModal.modalElement.classList.remove('active');
        }, 300);
      }
    });

    // Return scrolling of background when modal closed
    const doc = document.querySelector('body');
    doc.classList.remove('no-scroll');
  },
  nextCard: () => {
    // Get current index
    const currentIndex = teamModal.teamList.indexOf(teamModal.currentCard);

    // Get ID of next team member
    let nextId;
    if (currentIndex + 1 < teamModal.teamList.length) {
      nextId = teamModal.teamList[currentIndex + 1];
    } else {
      nextId = teamModal.teamList[0];
    }

    // Get Current and Next Slide Element
    const currentTeamCard = teamModal.teamModalPages.filter((page) => {
      return page.dataset.id === teamModal.currentCard;
    });

    const nextTeamCard = teamModal.teamModalPages.filter((page) => {
      return page.dataset.id === nextId;
    });

    // Hide Current card & show Next card
    currentTeamCard[0].classList.remove('active');
    nextTeamCard[0].classList.add('active');

    // Update currentCard variable
    teamModal.currentCard = nextTeamCard[0].dataset.id;

    // Set button state
    teamModal.setButtons();
  },
  prevCard: () => {
    // Get current index
    const currentIndex = teamModal.teamList.indexOf(teamModal.currentCard);

    // Get ID of prev team member
    let prevId;
    if (currentIndex > 0) {
      prevId = teamModal.teamList[currentIndex - 1];
    } else {
      prevId = teamModal.teamList[teamModal.teamList.length - 1];
    }

    // Get current and prev slide element
    const currentTeamCard = teamModal.teamModalPages.filter((page) => {
      return page.dataset.id === teamModal.currentCard;
    });

    const prevTeamCard = teamModal.teamModalPages.filter((page) => {
      return page.dataset.id === prevId;
    });

    // Hide current slide and show prev slide
    currentTeamCard[0].classList.remove('active');
    prevTeamCard[0].classList.add('active');

    // update currentCard variable
    teamModal.currentCard = prevTeamCard[0].dataset.id;

    // Set button state
    teamModal.setButtons();
  },
  setButtons: () => {
    // Activate appropriate controls
    // Get Prev & Next buttons
    const nextButtons = teamModal.modalElement.querySelectorAll('.next');
    const prevButtons = teamModal.modalElement.querySelectorAll('.prev');

    if (teamModal.currentCard === teamModal.teamList[0]) {
      prevButtons.forEach((button) => {
        button.disabled = true;
        button.classList.remove('active');
      });
      nextButtons.forEach((button) => {
        button.disabled = false;
        button.classList.add('active');
      });
    } else if (teamModal.currentCard === teamModal.teamList[teamModal.teamList.length - 1]) {
      prevButtons.forEach((button) => {
        button.disabled = false;
        button.classList.add('active');
      });
      nextButtons.forEach((button) => {
        button.disabled = true;
        button.classList.remove('active');
      });
    } else {
      prevButtons.forEach((button) => {
        button.disabled = false;
        button.classList.add('active');
      });
      nextButtons.forEach((button) => {
        button.disabled = false;
        button.classList.add('active');
      });
    }
  },
  clickOutsideToClose: (e) => {
    if (e.target.id === 'team-modal') {
      teamModal.closeModal();
    }
  },
};

export default teamModal;
